module.exports = __webpack_public_path__ + "static/media/Black_Green_URL.a17061d3.png";